export default {
	tenantId: "walaa_production",
	appId: "admin_portal",
	fileSystem: {
		bucketName: "walaa--prod",
	},
}
